module.exports = __webpack_public_path__ + "img/fcldcgq.4ea02c5d.png";